import { Breadcrumb, Form } from "antd";
import React, { useMemo } from "react";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import { ISubAdminPayload } from "../../../types/api/subAdmin";
import BuildingsTable from "./SubAdminTable";
import { useMessageApi } from "../../../provider/AntdNotification";
import {
  useBuildingDelete,
  useBuildingList,
  useBuildingSave,
} from "../../../hooks/api/buildings/hooks";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SubAdminTable from "./SubAdminTable";
import { useListSubAdminUsers, useSubAdminDelete } from "../../../hooks/api/subAdmins/hooks";
import SubAdminFrom from "./SubAdminFrom";

const SubAdminMainComp: React.FC<{ allowURLStateUpdate?: boolean }> = ({
  allowURLStateUpdate = true,
}) => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const isCreatePage = location.pathname === "/sub-admin/create";
  const isEditPage = !!id;

  const message = useMessageApi();
  const DEFAULT_NUQS_CONFIG = {
    throttleMs: !allowURLStateUpdate ? Infinity : 0,
  };

  const {
    data,
    refetchWithQuery: refetch,
    isFetching,
  } = useListSubAdminUsers({
    page: 1,
    limit: 20,
    type:"SubAdmin",
    ...DEFAULT_NUQS_CONFIG,
  });

  const subAdminList: ISubAdminPayload[] = useMemo(
    () => data?.data || [],
    [data]
  );

  const qData = data?.qData ?? { page: 1, limit: 20 };
  const { mutate: deleteSubAdmin } = useSubAdminDelete({ qData });

  const handleDelete = (id: string) => {
    deleteSubAdmin(
      { ids: id },
      {
        onSuccess: () => {
          message.success("Sub Admin deleted successfully");
        },
        onError: (err: any) => {
          const msg =
            err?.response?.data?.message ||
            err?.message ||
            "Failed to delete Sub Admin";

          message.error(msg);
        },
      }
    );
  };

  return (
    <div className="mb-6">
      <div className=" flex justify-between items-center">
        <h1 className="text-xl sm:text-3xl  sm:mb-2">
          {isCreatePage
            ? "Add new Sub Admin"
            : isEditPage
            ? "Edit Sub Admin"
            : "Sub Admins"}
        </h1>

        {!isCreatePage && !isEditPage && (
          <ButtonWrapper
            className="bg-primary text-white"
            onClick={() => navigate("/sub-admin/create")}
          >
            Create Sub Admin
          </ButtonWrapper>
        )}
        
      </div>



      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Dashboard", href: "/" }, { title: "Buildings" }]}
        />
      </div>
      <div>
        {isCreatePage || isEditPage ? (
          <SubAdminFrom qData={qData} id={id} />
        ) : (
          <SubAdminTable
            {...{
              data: subAdminList,
              refetch,
              qData,
              DEFAULT_NUQS_CONFIG,
              loading: isFetching,
              handleDelete,
            }}
          />
        )}
      </div>

    </div>
  );
};

export default SubAdminMainComp;
